<h1>Update Cab Details <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
<div class="row"  *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
<div class="row" *ngIf="dataLoaded">
    <div class="col-sm-12">
    <form [formGroup]="CabForm" (submit)="updateCabDetails()">
        <div class="form-group">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="form-label">Pickup Date</label>
                  <mat-form-field appearance="fill">
                      <mat-label>Pickup Date</mat-label>
                      <input matInput readonly formControlName="pickup_date" [matDatepicker]="picker1" [readonly]="modalData.status=='2' || modalData.status=='4'">
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field>
                  <div *ngIf="submitted && f.pickup_date.errors" class="invalid-feedback">
                      <div *ngIf="f.pickup_date.errors.required">Pickup Date is required</div>
                  </div>
                </div>
            </div>
            <div class="col-sm-6">
              <label class="form-label">Pickup Time</label>
              <input type="time" formControlName="pickup_time" class="form-control"  [readonly]="modalData.status=='2' || modalData.status=='4'" />
              <div *ngIf="submitted && f.pickup_time.errors" class="invalid-feedback">
                  <div *ngIf="f.pickup_time.errors.required">Pickup Time is required</div>
              </div>
          </div>
              <div class="col-sm-6">
                <label class="form-label" *ngIf="modalData.status=='1' || modalData.status=='2'">Pickup Point *</label>
                <label class="form-label" *ngIf="modalData.status=='3' || modalData.status=='4'">Drop Location *</label>
                <textarea class="form-control" formControlName="pickup_point" [ngClass]="{'readOnly': modalData.status=='2' || modalData.status=='4'}"></textarea>
                <div *ngIf="submitted && f.pickup_point.errors" class="invalid-feedback">
                    <div *ngIf="f.pickup_point.errors.required && (modalData.status=='1' || modalData.status=='2')" >Pickup point is required</div>
                    <div *ngIf="f.pickup_point.errors.required && (modalData.status=='3' || modalData.status=='4')" >Drop Location is required</div>
                </div>
            </div>
              <div class="col-sm-6" *ngIf="modalData.status=='1' || modalData.status=='3'">
                  <label class="form-label">Price *</label>
                  <input type="number" formControlName="price" class="form-control" />
                  <div *ngIf="submitted && f.price.errors" class="invalid-feedback">
                      <div *ngIf="f.price.errors.required">Cab Price is required</div>
                  </div>
              </div>
            <div class="col-sm-6">
              <div class="form-group">
                  <label class="form-label">Comments</label>
                  <textarea class="form-control" formControlName="comments"></textarea>
              </div>
            </div>
            </div>
        </div>
        <div class="card-footer">
            <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Update</button>
        </div>
        </form>
    </div>
</div>

